// The site-wide theme choice (Nav, 2026-10-04): System, Light or Dark, on every
// page, remembered on this device. Shared with the marketing site (same origin,
// same key). The presenter keeps its own choice and hands back on the way out.
import { platform } from "./platform";

export type ThemeChoice = "system" | "light" | "dark";
const KEY = "flp_theme";

export function themeChoice(): ThemeChoice {
  const v = platform.storage.get(KEY);
  return v === "light" || v === "dark" ? v : "system";
}

/** Puts the remembered choice on <html>; "system" leaves it to the device. */
export function applyTheme(choice: ThemeChoice = themeChoice()): void {
  if (choice === "system") delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = choice;
}

export function setTheme(choice: ThemeChoice): void {
  platform.storage.set(KEY, choice);
  applyTheme(choice);
}
